var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldGrid1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75 7.8H2C2 4.19 4.15 2.02 7.75 2v5.8zM16.25 7.8V2c3.6.02 5.75 2.19 5.75 5.8h-5.75zM16.25 22v-5.7H22c-.04 3.55-2.18 5.68-5.75 5.7zM7.75 22c-3.57-.02-5.71-2.15-5.75-5.7h5.75V22z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75 9.3v5.5H2V9.3h5.75zM22 9.3v5.5h-5.75V9.3H22zM14.75 9.3v5.5h-5.5V9.3h5.5zM14.75 2v5.8h-5.5V2h5.5zM14.75 16.3V22h-5.5v-5.7h5.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldGrid1);
export default __webpack_public_path__ + "static/media/vuesax-bold-grid-1.97f572f79b73eea07fad756059c142df.svg";
export { ForwardRef as ReactComponent };